var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-progress",on:{"click":_vm.toProgress}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-text"},[_c('div',[_vm._v("查看")]),_c('div',[_vm._v("学习进度")])])
}]

export { render, staticRenderFns }